import lazyLoading from '@/utils/lazyLoading';
const axios = require("axios");
import {
  getCookie
} from "@/utils/auth";
import {
  downFile,
  downMhFile
} from '@/api/file';
import {
  downFileModal
} from './downFile'
// 页面div拖动边缘 放大缩小效果

export function move(e, that, wid) {
  e.preventDefault();
  //算出鼠标相对元素的位置
  var disX = e.screenX;
  /* 保存原始的元素位置 */
  var leftOneBefore = that.$refs.contentOne.getBoundingClientRect()
    .width;
  var leftTwoBefore = that.$refs.contentTwo.getBoundingClientRect()
    .width;

  document.onmousemove = e => {
    //鼠标按下并移动的事件
    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
    var left = e.screenX - disX;
    var leftOne = leftOneBefore + left;
    var leftTwo = leftTwoBefore - left;

    if (leftTwo < 300 || leftOne < wid) {
      return;
    }
    that.contentOneStyleObj.width = leftOne + "px";
    // that.contentTwoStyleObj.width = leftTwo + "px";
    that.contentTwoStyleObj.marginLeft = leftOne + "px";
  };
  document.onmouseup = e => {
    document.onmousemove = null;
    document.onmouseup = null;
  };
}
export function moveTwo(e, that, wid) {
  e.preventDefault();
  //算出鼠标相对元素的位置
  var disX = e.screenX;
  /* 保存原始的元素位置 */
  var leftOneBefore = that.$refs.contentTree.getBoundingClientRect()
    .width;
  var leftTwoBefore = that.$refs.contentFour.getBoundingClientRect()
    .width;

  document.onmousemove = e => {
    //鼠标按下并移动的事件
    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
    var left = e.screenX - disX;
    var leftOne = leftOneBefore + left;
    var leftTwo = leftTwoBefore - left;
    if (leftTwo < 300 || leftOne < wid) {
      return;
    }
    that.contentTreeStyleObj.width = leftOne + "px";
    that.contentFourStyleObj.width = leftTwo + "px";
    that.contentFourStyleObj.left = leftOne + "px";
  };
  document.onmouseup = e => {
    document.onmousemove = null;
    document.onmouseup = null;
  };
}

export function moveTree(e, that, wid, maxWid) {
  e.preventDefault();
  //算出鼠标相对元素的位置
  var disX = e.screenX;
  /* 保存原始的元素位置 */
  var leftOneBefore = that.$refs.contentOne.getBoundingClientRect()
    .width;
  var leftTwoBefore = that.$refs.contentTwo.getBoundingClientRect()
    .width;

  document.onmousemove = e => {
    //鼠标按下并移动的事件
    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
    var left = e.screenX - disX;
    var leftOne = leftOneBefore + left;
    var leftTwo = leftTwoBefore - left;

    if (leftTwo < maxWid || leftOne < wid) {
      return;
    }
    that.contentOneStyleObj.width = leftOne + "px";
    that.contentTwoStyleObj.width = leftTwo + "px";
    that.contentTwoStyleObj.left = leftOne + "px";
  };
  document.onmouseup = e => {
    document.onmousemove = null;
    document.onmouseup = null;
  };
}


// 文件的预览
export function getHzm(file) {
  return file.name ? '.' + file.name.split(".")[file.name.split(".").length - 1] : '.' + file.attaname.split(".")[file.attaname.split(".").length - 1]
}

export function toLower(str) {
  var ind = str.lastIndexOf("."); //取到文件名开始到最后一个点的长度
  var len = str.length; //取到文件名长度
  var hzm = str.substring(ind + 1, len); //截
  var name = str.substring(0, ind).trim(); //去掉后缀名的文件名
  return (name + '.' + hzm.toLowerCase()); //返回后缀名转小写完整的文件名
}

// 时间截取
export function subTimer(str, type) {
  // type 想要截取的字符格式  year 年  month月  day 天  h 小时  s分  m毫秒  yM 年月   yMD 年月日  date 年月日时分
  var arr = str.split(' ')
  var returnName
  if (arr.length > 0) {
    var yearArr = arr[0].split('-')
    if (arr.length == 2) {
      var housArr = arr[1].split(':')
      // 说明str是 2019-12-12 12:12:12 格式
      switch (type) {
        case 'year':
          returnName = yearArr[0]
          break;
        case 'month':
          returnName = yearArr[1]
          break;
        case 'day':
          returnName = yearArr[2]
          break;
        case 'yM':
          returnName = yearArr[0] + '-' + yearArr[1]
          break;
        case 'yMD':
          returnName = yearArr[0] + '-' + yearArr[1] + '-' + yearArr[2]
          break;
        case 'h':
          returnName = housArr[0]
          break;
        case 's':
          returnName = housArr[1]
          break;
        case 'm':
          returnName = housArr[2]
          break;
        case 'date':
          returnName = yearArr[0] + '-' + yearArr[1] + '-' + yearArr[2] + ' ' + housArr[0] + ':' + housArr[1]
          break;
        default:
          returnName = str
          break;
      }
    } else {
      // str是 2019-12-12格式
      switch (type) {
        case 'year':
          returnName = yearArr[0]
          break;
        case 'month':
          returnName = yearArr[1]
          break;
        case 'day':
          returnName = yearArr[2]
          break;
        case 'yM':
          returnName = yearArr[0] + '-' + yearArr[1]
          break;
        case 'yMD':
          returnName = yearArr[0] + '-' + yearArr[1] + '-' + yearArr[2]
          break;
        default:
          returnName = str
          break;
      }
    }
  }
  // console.log(returnName)
  return returnName
}

// 获取地址栏字符串
export function getQueryString(name, url) {
  var regexS = "[\\?&]" + name + "=([^&#]*)"; //匹配name参数对  
  var regex = new RegExp(regexS);
  var results = regex.exec(url || window.location.href); //过滤超链接  
  if (results == null) {
    return "";
  } else {
    return results[1];
  }
}

// 当前系统时间
export function getDateTimer() {
  var date = new Date();
  var seperator1 = "-";

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hour = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hour >= 0 && hour <= 9) {
    hour = "0" + hour;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hour + ":" + minutes + ":" + seconds;
  return currentdate;
}
export function getYestoday() {
  var yesterday = new Date();
  var yesterday_milliseconds = yesterday.getTime() - 1000 * 60 * 60 * 24;

  yesterday.setTime(yesterday_milliseconds);

  var strYear = yesterday.getFullYear();
  var strDay = yesterday.getDate();
  var strMonth = yesterday.getMonth() + 1;
  if (strMonth < 10) {
    strMonth = "0" + strMonth;
  }
  if (strDay < 10) {
    strDay = "0" + strDay;
  }
  var datastr;
  datastr = strYear + "-" + strMonth + "-" + strDay;
  return datastr;
}

// 判断用户使用pc or  phone
export function IsPC() {
  var flag = true;
  // if ((navigator.userAgent.match(
  //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  // ))) {
  //   // 手机端
  //   flag = false;
  // } else {
  //   flag = true;
  //   // PC端
  // }
  return flag;
}

export function handleFileDown(flag, file, url) {
  if (flag == 2) {
    downFileModal(url, file);
  } else if (flag == 1) {
    var sessionId = getCookie("Session-Id")
    if (sessionId) {
      downFile({
        fileid: file.id,
        flag: 1 //用于区分是门户还是平台
      }).then(res => {
        if (res.data) {
          downFileModal(res.data, file);
        }
      });
    } else {
      downMhFile({
        fileid: file.id,
        flag: 1 //用于区分是门户还是平台
      }).then(res => {
        if (res.data) {
          downFileModal(res.data, file);
        }
      });
    }
  }

}




// WEBPACK FOOTER //
// ./src/utils/util.js